<template>
  <div id="state_dialog_PC">
    <div class="top"><img src="../../assets/img/logo2.png" alt="" /></div>
    <div class="content">
      <div class="dialog-title">{{ dialogData.title }}</div>
      <!-- 申请状态:验证身份,重置密码 -->
      <!-- <div class="verification">
        <div class="verification_outer">
          <div class="ver3"></div>
          <div class="ver1">
            <div class="ver1_l">
              <div class="ver1_l_c"></div>
            </div>
            <div class="ver1_center"></div>
            <div class="ver1_l">
              <div class="ver1_l_c"></div>
            </div>
          </div>
          <div class="ver2">
            <span>验证身份</span>
            <span>重置密码</span>
          </div>
        </div>
      </div> -->
      <!-- 密码重置成功状态 -->
      <div class="content_box">
        <img class="one" src="../../assets/img/shtg.png" alt="" />
        <div class="two">密码重置成功</div>
        <div class="three">恭喜你!密码修改成功,请返回登录页进入系统!</div>
        <div class="four" @click="returnLogin">返回登录</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "state_dialog_PC",
  props: {
    myDialogData: {
      type: Object,
      default: function () {
        return {
          flag: true,
          title: "注册",
          data: [],
          stateNameOne: "验证身份",
          stateNameTwo: "重置密码",
        };
      },
    },
  },
  data() {
    return {
      dialogData: this.myDialogData,
    };
  },
  methods: {
    returnLogin() {
      this.$router.push("/");
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
#state_dialog_PC {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .top {
    width: 25rem;
    height: 5rem;
    box-sizing: border-box;
    margin: 10px 0;

    > img {
      width: 100%;
      height: 100%;
    }
  }
  .content {
    border-radius: 10px;
    width: 75rem;
    height: 70%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(255, 255, 255, 1);

    .dialog-title {
      width: 80%;
      height: 50px;
      line-height: 50px;
      font-size: 18px;
      font-weight: 700;
      border-bottom: 1px solid rgba(204, 204, 204, 1);
    }
    .verification {
      width: 100%;
      height: 3.75rem;
      display: flex;
      justify-content: center;
      .verification_outer {
        width: 72%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-end;

        .ver1 {
          width: 84%;
          display: flex;
          align-items: center;
          margin-right: 17px;
          .ver1_l {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            background: rgba(152, 188, 255, 1);
            display: flex;
            justify-content: center;
            align-items: center;

            .ver1_l_c {
              width: 9px;
              height: 9px;
              border-radius: 50%;
              background: rgba(51, 125, 255, 1);
            }
          }
          .ver1_center {
            flex: 1;
            height: 8px;
            background: rgba(224, 241, 255, 1);
          }
        }
        .ver2 {
          width: 88%;
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .content_box {
      width: 96%;
      height: 340px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .outer {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .outer_word {
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 2px;
          box-sizing: border-box;
          margin: 20px 0 8px 0;
          color: rgba(0, 0, 0, 1);
        }
        .outer_bottom {
          width: 100%;
          height: 15px;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          margin: 15px 0;
          > img {
            width: 9px;
            height: 9px;
          }
          > span {
            font-size: 10px;
            font-weight: 400;
            letter-spacing: 2px;
            color: rgba(153, 153, 153, 1);
          }
        }
      }
      .one {
        width: 70px;
        height: 70px;
        box-sizing: border-box;
        margin: 49px 0 26px 0;
      }
      .two {
        font-size: 18px;
        font-weight: 600;
      }
      .three {
        font-size: 12px;
        font-weight: 400;
        box-sizing: border-box;
        margin: 25px 0 20px 0;
        color: rgba(166, 166, 166, 1);
        letter-spacing: 2px;
      }
      .four {
        width: 200px;
        height: 32px;
        opacity: 1;
        border-radius: 5px;
        background: rgba(0, 79, 146, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #fff;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
